<template>
  <div>
    <ca-heading text="Pagamento de Autônomo" />
    <ca-row>
      <ca-col size="4">
        <ca-button theme="primary" @click="onGeneratePayment">Gerar Pagamento</ca-button>
        <ca-button class="ca-u-min-margin-left" @click="openRpaForm">
          RPA
        </ca-button>
      </ca-col>
      <ca-col size="3" offset="5">
        <ca-monthpicker v-model="selectedDate"></ca-monthpicker>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-loader v-if="showLoading"></ca-loader>

        <ca-table v-else>
          <ca-tr slot="header">
            <ca-th>Nome</ca-th>
            <ca-th>CPF</ca-th>
            <ca-th>Categoria</ca-th>
            <ca-th align="right">Liquido a Receber</ca-th>
            <ca-th size="4"></ca-th>
            <ca-th size="4"></ca-th>
          </ca-tr>

          <ca-tr
            v-for="(payment, index) in payments.content"
            :key="index"
            @click="onDetails(payment)">
            <ca-td>{{ payment.selfEmployed.name }}</ca-td>
            <ca-td>{{ payment.selfEmployed.cpf | caCpf }}</ca-td>
            <ca-td>{{ payment.selfEmployed.category.description }}</ca-td>
            <ca-td align="right">{{ payment.netTotal | brazilianCurrency }}</ca-td>
            <ca-td align="right">
              <ca-button
                class="ca-u-min-margin-right"
                size="small"
                @click.stop="onDelete(payment.id, index)">
                Excluir
              </ca-button>
            </ca-td>
            <ca-td>
              <ca-request-button
                :on-request="() => onRpa(payment)"
                :on-request-success="onRpaSuccess"
                :on-request-error="onRpaError"
                size="small"
                @click.native.stop="() => {}">
                RPA
              </ca-request-button>
            </ca-td>
          </ca-tr>
        </ca-table>
      </ca-col>
    </ca-row>

    <ca-row v-if="payments.totalPages > 1" vertical-offset="2">
      <ca-col>
        <ca-pagination
          v-model="currentPage"
          :total-pages="payments.totalPages"
          class="ca-u-flex ca-u-align-items--center ca-u-justify-content--center">
        </ca-pagination>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import moment from 'moment';
import { getFormattedPeriod } from 'packages/common/utils/format';
import { openPdf } from 'packages/common/utils/file';
import { getPayments, deletePayment, getRpa } from './paymentService';
import DetailsRollover from './modals/DetailsRollover';


export default {
  name: 'PaymentPage',
  data() {
    return {
      showLoading: false,
      selectedDate: moment().format('DD/MM/YYYY'),
      currentPage: 0,
      payments: [],
    };
  },
  watch: {
    currentPage() {
      this.setPayment();
    },
    selectedDate() {
      this.currentPage = 0;
      this.setPayment();
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.setPayment();
    },
    async setPayment() {
      this.showLoading = true;
      try {
        this.payments = await getPayments(this.selectedDate, this.currentPage);
      } catch (e) {
        this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
      } finally {
        this.showLoading = false;
      }
    },
    onDetails({ id }) {
      this.$dialogModal(DetailsRollover, {
        props: {
          id,
          period: getFormattedPeriod(this.selectedDate),
        },
      }).open();
    },
    onGeneratePayment() {
      this.$router.push({ name: 'PaymentFormPage' });
    },
    onDelete(paymentId, index) {
      this.$caConfirm({
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente excluir este pagamento?',
        onConfirm: () => {
          deletePayment(paymentId)
            .then(() => {
              this.$delete(this.payments.content, index);
              this.$toaster.success('Pagamento excluído com sucesso.');
            })
            .catch(() => {
              this.$toaster.error('Erro ao excluir o pagamento');
            });
        },
      });
    },
    onRpa(payment) {
      const params = {
        type: 'SELF_EMPLOYED_PAYMENT_RECEIPT',
        format: 'PDF',
        competence: getFormattedPeriod(this.selectedDate),
        id: payment.id,
      };

      return getRpa(params);
    },
    onRpaSuccess(response) {
      openPdf(response);
    },
    onRpaError() {
      this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
    },
    openRpaForm() {
      this.$router.push({ name: 'RpaForm' });
    },
  },
};
</script>
